import { lazy, Suspense } from 'react';
import { createBrowserRouter, createRoutesFromElements, Route } from 'react-router-dom';
import { Box, CircularProgress } from '@material-ui/core';
import { UrlPathsWithAllLanguages } from '~/hooks/useRouteNames';
import App from '~/App';
import MainLayout from '~/components/MainLayout';
import { ProtectedRoute } from './ProtectedRoute';

const HomePage = lazy(() => import('~/pages'));
const ProfilePage = lazy(() => import('~/pages/Profile'));
const FileApplication = lazy(() => import('~/pages/File'));
const GlobalStatus = lazy(() => import('~/pages/IPManagement/GlobalStatus'));
const IPWatch = lazy(() => import('~/pages/IPManagement/Watch'));
const IPTrademarks = lazy(() => import('~/pages/IPManagement/Trademarks'));
const MyApplication = lazy(() => import('~/pages/MyApplication'));
const ApplicationDetail = lazy(() => import('~/pages/MyApplication/Details'));
const Payment = lazy(() => import('~/pages/Payment'));
const PaymentTy = lazy(() => import('~/pages/Payment/PaymentTy'));
const PaymentTyAdditional = lazy(() => import('~/pages/Payment/PaymentTyAdditional'));
const VerifyPage = lazy(() => import('~/pages/Verify'));
const ErrorPage = lazy(() => import('~/pages/Error'));
const FileThankYou = lazy(() => import('~/pages/File/ThankYou'));

export const folioClientRouter = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<App />}>
      {UrlPathsWithAllLanguages.Home.map((route, index) => (
        <Route
          key={`Home_Route_${index}`}
          path={route}
          element={
            <Suspense
              fallback={
                <Box display="flex" justifyContent="center" padding="40px">
                  <CircularProgress size={24} thickness={6} />
                </Box>
              }
            >
              <HomePage />
            </Suspense>
          }
        />
      ))}
      {UrlPathsWithAllLanguages.Profile.map((route, index) => (
        <Route
          key={`Profile_Route_${index}`}
          path={route}
          element={
            <Suspense
              fallback={
                <Box display="flex" justifyContent="center" padding="40px">
                  <CircularProgress size={24} thickness={6} />
                </Box>
              }
            >
              <ProfilePage />
            </Suspense>
          }
        />
      ))}

      <Route element={<MainLayout />}>
        {UrlPathsWithAllLanguages.FileAnApplication.map((route, index) => (
          <Route
            key={`File_Application_Route_${index}`}
            path={`${route}/:id?`}
            element={
              <Suspense
                fallback={
                  <Box display="flex" justifyContent="center" padding="40px">
                    <CircularProgress size={24} thickness={6} />
                  </Box>
                }
              >
                <FileApplication />
              </Suspense>
            }
          />
        ))}

        {UrlPathsWithAllLanguages.FileThankYou.map((route, index) => (
          <Route
            key={`File_ThankYou_Route_${index}`}
            path={`${route}/:ipType/:id?`}
            element={
              <Suspense
                fallback={
                  <Box display="flex" justifyContent="center" padding="40px">
                    <CircularProgress size={24} thickness={6} />
                  </Box>
                }
              >
                <FileThankYou />
              </Suspense>
            }
          />
        ))}

        {UrlPathsWithAllLanguages.Watch.map((route, index) => (
          <Route
            key={`Watch_Route_${index}`}
            path={route}
            element={
              <Suspense
                fallback={
                  <Box display="flex" justifyContent="center" padding="40px">
                    <CircularProgress size={24} thickness={6} />
                  </Box>
                }
              >
                <IPWatch />
              </Suspense>
            }
          />
        ))}

        {UrlPathsWithAllLanguages.TrademarkManagement.map((route, index) => (
          <Route
            key={`Trademark_Management_Route_${index}`}
            path={route}
            element={
              <Suspense
                fallback={
                  <Box display="flex" justifyContent="center" padding="40px">
                    <CircularProgress size={24} thickness={6} />
                  </Box>
                }
              >
                <IPTrademarks />
              </Suspense>
            }
          />
        ))}

        <Route element={<ProtectedRoute />}>
          {UrlPathsWithAllLanguages.GlobalStatus.map((route, index) => (
            <Route
              key={`Global_Status_Route_${index}`}
              path={route}
              element={
                <Suspense
                  fallback={
                    <Box display="flex" justifyContent="center" padding="40px">
                      <CircularProgress size={24} thickness={6} />
                    </Box>
                  }
                >
                  <GlobalStatus />
                </Suspense>
              }
            />
          ))}

          {UrlPathsWithAllLanguages.MyApplication.map((route, index) => (
            <Route
              key={`My_Application_Route_${index}`}
              path={route}
              element={
                <Suspense
                  fallback={
                    <Box display="flex" justifyContent="center" padding="40px">
                      <CircularProgress size={24} thickness={6} />
                    </Box>
                  }
                >
                  <MyApplication />
                </Suspense>
              }
            />
          ))}

          {UrlPathsWithAllLanguages.MyApplication.map((route, index) => (
            <Route
              key={`My_Application_Id_Route_${index}`}
              path={`${route}/:id`}
              element={
                <Suspense
                  fallback={
                    <Box display="flex" justifyContent="center" padding="40px">
                      <CircularProgress size={24} thickness={6} />
                    </Box>
                  }
                >
                  <ApplicationDetail />
                </Suspense>
              }
            />
          ))}

          {UrlPathsWithAllLanguages.Payment.map((route, index) => (
            <Route
              key={`Payment_Route_${index}`}
              path={route}
              element={
                <Suspense
                  fallback={
                    <Box display="flex" justifyContent="center" padding="40px">
                      <CircularProgress size={24} thickness={6} />
                    </Box>
                  }
                >
                  <Payment />
                </Suspense>
              }
            />
          ))}

          {UrlPathsWithAllLanguages.Payment.map((route, index) => (
            <Route
              key={`Payment_Finish__${index}`}
              path={`${route}/:paymentId/ty`}
              element={
                <Suspense
                  fallback={
                    <Box display="flex" justifyContent="center" padding="40px">
                      <CircularProgress size={24} thickness={6} />
                    </Box>
                  }
                >
                  <PaymentTy />
                </Suspense>
              }
            />
          ))}

          {UrlPathsWithAllLanguages.Payment.map((route, index) => (
            <Route
              key={`My_Application_Ty_Add_Route_${index}`}
              path={`${route}/:paymentId/ty/add`}
              element={
                <Suspense
                  fallback={
                    <Box display="flex" justifyContent="center" padding="40px">
                      <CircularProgress size={24} thickness={6} />
                    </Box>
                  }
                >
                  <PaymentTyAdditional />
                </Suspense>
              }
            />
          ))}
        </Route>

        {UrlPathsWithAllLanguages.Application.map((route, index) => (
          <Route
            key={`Application_Route_${index}`}
            path={route}
            element={
              <Suspense
                fallback={
                  <Box display="flex" justifyContent="center" padding="40px">
                    <CircularProgress size={24} thickness={6} />
                  </Box>
                }
              >
                <Payment />
              </Suspense>
            }
          />
        ))}

        {UrlPathsWithAllLanguages.Verify.map((route, index) => (
          <Route
            key={`Verify_Route_${index}`}
            path={route}
            element={
              <Suspense
                fallback={
                  <Box display="flex" justifyContent="center" padding="40px">
                    <CircularProgress size={24} thickness={6} />
                  </Box>
                }
              >
                <VerifyPage />
              </Suspense>
            }
          />
        ))}

        {UrlPathsWithAllLanguages.IP.map((route, index) => (
          <Route
            key={`IP_Route_${index}`}
            path={route}
            element={
              <Suspense
                fallback={
                  <Box display="flex" justifyContent="center" padding="40px">
                    <CircularProgress size={24} thickness={6} />
                  </Box>
                }
              >
                <IPTrademarks />
              </Suspense>
            }
          />
        ))}
      </Route>

      <Route
        path="*"
        element={
          <Suspense
            fallback={
              <Box display="flex" justifyContent="center" padding="40px">
                <CircularProgress size={24} thickness={6} />
              </Box>
            }
          >
            <ErrorPage />
          </Suspense>
        }
      />
    </Route>
  )
);
